export default [
  {
    title: '月份',
    key: 'tdate',
    width: 80,
    type: 'basic'
  },
  {
    title: '账号ID',
    key: 'accountId',
    width: 60,
    type: 'basic'
  },
  {
    title: '账号名称',
    key: 'adAccount',
    width: 180,
    overflow: true,
    type: 'basic'
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: 100,
    type: 'basic'
  },
  {
    title: '开户主体',
    key: 'companyName',
    width: 100,
    type: 'basic'
  },
  {
    title: '计划主ID',
    key: 'advertiserId',
    overflow: true,
    type: 'basic'
  },
  {
    title: '管理人',
    key: 'opNames',
    width: 64,
    overflow: true,
    type: 'basic'
  },
  {
    title: '开票主体',
    key: 'invoiceUnit',
    width: 180,
    overflow: true,
    type: 'basic'
  },
  {
    title: '代理商',
    key: 'agentName',
    width: 180,
    overflow: true,
    type: 'basic'
  },
  {
    title: '返点',
    key: 'rebate',
    width: 80,
    type: 'basic'
  },
  {
    title: '账号状态',
    key: 'accountStatusDesc',
    width: 60,
    type: 'basic'
  },
  {
    title: '结算方式',
    key: 'settleTypeName',
    width: 80,
    type: 'basic'
  },
  {
    title: '项目组',
    key: 'projectGroupNames',
    width: 120,
    type: 'basic'
  },
  {
    title: '数据关联模式',
    key: 'dataModel',
    width: 100,
    type: 'basic'
  },
  {
    title: '最后同步时间',
    key: 'lastSynTime',
    width: 140,
    type: 'basic'
  },
  {
    title: '同步状态',
    key: 'synStatusDesc',
    width: 140,
    type: 'basic'
  },
  {
    title: '同步失败原因',
    key: 'failMsg',
    width: 140,
    overflow: true,
    type: 'basic'
  },
  {
    title: '总消耗(天工) ',
    key: 'paperUseAmount',
    width: 140,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '赠款消耗(天工)',
    key: 'giveAmount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '总消耗(爬取)',
    key: 'finaSumAmount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '总消耗差异(爬取-天工)',
    key: 'amountDiff',
    width: 160,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '账面消耗(爬取)',
    key: 'finaPaperAmount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '赠款消耗(爬取)',
    key: 'finaGiveAmount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '共享赠款/返货赠款/框返消耗',
    key: 'finaShareGiveAmount',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '赠款存入(爬取)',
    key: 'income',
    width: 120,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '月末总余额(爬取)',
    key: 'balance',
    width: 140,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '月末账面余额(爬取)',
    key: 'paperBalance',
    width: 140,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '月末赠款余额(爬取)',
    key: 'grantBalance',
    width: 140,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '月末共享赠款余额(爬取)',
    key: 'shareBalance',
    width: 160,
    type: 'basic',
    sortable: 'custom'
  },
  {
    title: '本金消耗',
    key: 'principalAmount',
    width: 120,
    type: 'basic'
  },
  {
    title: '赠款本金消耗',
    key: 'principalGiveAmount',
    width: 120,
    type: 'basic'
  },
  {
    title: '共享赠款本金消耗',
    key: 'principalShareGiveAmount',
    width: 120,
    type: 'basic'
  },
  {
    title: '月末本金总余额',
    key: 'principalBalance',
    width: 120,
    type: 'basic'
  },
  {
    title: '月末本金余额',
    key: 'principalPaperBalance',
    width: 120,
    type: 'basic'
  },
  {
    title: '月末赠款本金余额',
    key: 'principalGrantBalance',
    width: 120,
    type: 'basic'
  },
  {
    title: '月末共享赠款本金余额',
    key: 'principalShareBalance',
    width: 140,
    type: 'basic'
  }
]
